import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getRankingList = (id) => httpClient.get(apis.GET_RANKING_LIST + id);

export const getRankingDetail = (payload) =>
  httpClient.get(apis.GET_RANKING_DETAIL + payload.courseId + '/' + payload.type);
